import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';
import translationES from './locales/es/translation.json';
import { getUserInfo } from 'utils/auth';

// 翻译资源初始化
const resources = {
  en: {
    translation: translationEN
  },
  zh: {
    translation: translationZH
  },
  es: {
    translation: translationES
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // 不需要转义React内容
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'swiftx_language',
    }
  })
  .then(() => {
    // 应用启动时，如果用户已登录，优先使用数据库中的语言偏好
    const userInfo = getUserInfo();
    if (userInfo?.account?.language) {
      // 规范化语言代码，只取前两位（如 'zh-CN' -> 'zh'）
      const accountLanguage = userInfo.account.language.toLowerCase().split('-')[0];
      // 如果当前 i18n 语言与数据库中的语言不同，切换到数据库中的语言
      // 同时保存到 localStorage，确保一致性
      const currentLang = (i18n.resolvedLanguage || i18n.language || 'en').toLowerCase().split('-')[0];
      if (currentLang !== accountLanguage) {
        i18n.changeLanguage(accountLanguage);
      }
    }
    // 如果用户未登录，i18n 会从 localStorage 读取（通过 LanguageDetector）
  });


type TFunction = (key: string, options?: any) => string;
export const t = i18n.t as TFunction;  

// 运单状态国际化
export const ost = (status: string | number | undefined): string => {
  if (!status) return '-';
  switch (status) {
      case 'CREATED': return t('enum.overallStatus.CREATED');
      case 'CANCELLED': return t('enum.overallStatus.CANCELLED');
      case 'ARRIVED_ORIGIN_HUB': return t('enum.overallStatus.ARRIVED_ORIGIN_HUB');
      case 'PENDING_SHIPMENT': return t('enum.overallStatus.PENDING_SHIPMENT');
      case 'LINEHAUL_PENDING_SHIPMENT': return t('enum.overallStatus.LINEHAUL_PENDING_SHIPMENT');
      case 'FEEDER_PENDING_SHIPMENT': return t('enum.overallStatus.FEEDER_PENDING_SHIPMENT');
      case 'HANDED_OVER': return t('enum.overallStatus.HANDED_OVER');
      case 'IN_TRANSIT': return t('enum.overallStatus.IN_TRANSIT');
      case 'ARRIVED_DESTINATION_HUB': return t('enum.overallStatus.ARRIVED_DESTINATION_HUB');
      case 'ARRIVED_WHS': return t('enum.overallStatus.ARRIVED_WHS');
      case 'WAITING_FOR_DELIVERY': return t('enum.overallStatus.WAITING_FOR_DELIVERY');
      case 'DELIVERY_IN_PROGRESS': return t('enum.overallStatus.DELIVERY_IN_PROGRESS');
      case 'PRE_DELIVERED': return t('enum.overallStatus.PRE_DELIVERED');
      case 'DELIVERED': return t('enum.overallStatus.DELIVERED');
      case 'DELIVERY_FAILED': return t('enum.overallStatus.DELIVERY_FAILED');
      case 'PENDING_INTERCEPTION': return t('enum.overallStatus.PENDING_INTERCEPTION');
      case 'INTERCEPTED': return t('enum.overallStatus.INTERCEPTED');
      case 'RETURN_STARTED': return t('enum.overallStatus.RETURN_STARTED');
      case 'RETURNED': return t('enum.overallStatus.RETURNED');
      case 'HOLDING': return t('enum.overallStatus.HOLDING');
      case 'RETURN_ARRIVED_DESTINATION_HUB': return t('enum.overallStatus.RETURN_ARRIVED_DESTINATION_HUB');
      case 'PICKUP_FAILED': return t('enum.overallStatus.PICKUP_FAILED');
      case 'DESTROYED': return t('enum.overallStatus.DESTROYED');
      case 'MISSING': return t('enum.overallStatus.MISSING');
      case 'DAMAGED': return t('enum.overallStatus.DAMAGED');
      default: return String(status);
  }
};


export default i18n; 